/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Article } from '../../models/article';

export interface GetArticlesByMagasin$Params {
  /**
   * id magasin
   */
  'id-magasin': string;
}

export function getArticlesByMagasin(
  http: HttpClient,
  rootUrl: string,
  params: GetArticlesByMagasin$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<Article>>> {
  const rb = new RequestBuilder(rootUrl, getArticlesByMagasin.PATH, 'get');
  if (params) {
    rb.path('id-magasin', params['id-magasin'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Article>>;
    })
  );
}

getArticlesByMagasin.PATH = '/v1/magasins/{id-magasin}/articles';
